import React, { Component } from 'react';
import { Fstyr } from '../../components/FstyrComponents/Fstyr.js';
import { DateFormatter } from '../../components/HelperComponents/DateFormatter'
import URL from '../../Constants/URL.js'
import { fetchModel } from '../../components/HelperComponents/FetchExtension';
import { WorkshopCardVm } from '../../Models/WorkshopCardVm';
import { filterCardStatuses, filterCardStatusesPolice } from '../../components/HelperComponents/FilterCardStatuses.js';
import { GetStatusVm, GetStatusId, GetStatusName } from '../../components/HelperComponents/StatusHelper';
import { formatAuthorizationNumber } from '../../components/HelperComponents/Helpers.js';
import { ValidationType } from '../../Constants/ValidationTypes';
import { formatAddress } from '../../components/HelperComponents/AddressFormatter.js';
import { cardNumberFromHRef } from '../../components/HelperComponents/GetCardNumberFromHRef.js';

type Props = {};

type State = {
  cardFound: boolean,
  showSpinner: boolean,
  showStatusChange: boolean,

  //Button Press
  searchButtonPressed: boolean,

  //Validation
  cardNumberIsValid: boolean,

  // input
  cardNumberInput: string,

  //status change
  newCardStatusId: number,

  workshopCardVm: WorkshopCardVm,
};

export default class SearchWorkShopCard extends Component<Props, State> {
  static displayName = SearchWorkShopCard.name;
  private toastRef: React.RefObject<any>;
  private baseState: State;

  constructor(props: Props) {
    super(props);
    this.toastRef = React.createRef();

    this.state = {
      cardFound: false,
      showSpinner: false,
      showStatusChange: false,
      searchButtonPressed: false,
      cardNumberIsValid: false,
      cardNumberInput: "DK",
      newCardStatusId: 0,
      workshopCardVm: new WorkshopCardVm(),
    };
    this.baseState = this.state
  }

  componentDidMount() {
    this.setState({ cardNumberInput: cardNumberFromHRef() }, () => {
      if (this.state.cardNumberInput.length === 16) {
        this.fetchWorkshopCard()
      }
    })
  }

  fetchWorkshopCard() {
    this.setState({ searchButtonPressed: true }, () => {
      if (this.state.cardNumberIsValid) {
        this.clearPage(false);
        this.setState({ showSpinner: true })

        fetchModel("GET", URL + "/api/WorkshopCard/GetWorkshopCard", this.state.cardNumberInput, WorkshopCardVm)
          .then(model => {
            this.setState({ workshopCardVm: model[0], cardFound: true })
          })
          .catch(error => this.showErrorToast(error))
          .finally(() => this.setState({ showSpinner: false }))
      }
    })
  }


  clearPage(clearInputs: boolean) {
    if (clearInputs) {
      this.setState(this.baseState)
    } else {
      this.setState({
        cardFound: false,
        showSpinner: false,
        showStatusChange: false,
        newCardStatusId: 0,
        workshopCardVm: new WorkshopCardVm(),
      })
    }
  }

  showErrorToast(error: string) {
    if (error === "No result") {
      this.toastRef.current.show("Værkstedskort", "Der findes ikke et værkstedskort på det søgte kortnummer", "warning")
    }
    else if (error === "Failed response") {
      this.toastRef.current.show("Fejl", "Kan ikke forbinde til databasen", "error")
    }
    else {
      this.toastRef.current.show("Fejl", "Der skete en ukendt fejl", "error")
    }
  }

  changeCardStatus() {
    let model = Object.assign({}, this.state.workshopCardVm);
    model.Status = GetStatusVm(this.state.newCardStatusId)

    let success = true;

    let requestInfo = {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(model)
    }

    fetch(URL + "/api/workshopcard/ChangeCardStatus", requestInfo)
      .then(response => response.json())
      .then((result) => {
        if (!result.valid) {
          success = false
        }
        this.fetchWorkshopCard();
      })
      .catch(() => success = false)
      .finally(
        () => {
          success ? this.toastRef.current.show("Skift status", "Kortets status er skiftet.", "success")
            : this.toastRef.current.show("Skift status", "Kortets status blev ikke skiftet.", "error")
        }
      )


  }

  render() {
    return (
      <>
        <Fstyr.Toast ref={this.toastRef} />
        <Fstyr.Segment
          title="Søg Værkstedskort"
          isPageTitle={true}
        >
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button
              label="Ryd side"
              onClick={() => { this.clearPage(true) }}
            />
          </div>
        </Fstyr.Segment>

        <Fstyr.Segment
          title="Angiv kortnummer"
        >

          <Fstyr.Input
            value={this.state.cardNumberInput}
            label="Kortnummer"
            onChange={(value: string) => this.setState({ cardNumberInput: value })}
            validation={true}
            validationType={ValidationType.cardNumber}
            errorBodyText={"Forkert format (landekode + 14 tegn)"}
            errorExampleText={"f.eks. DK00000050121001"}
            onEnterPressed={() => this.fetchWorkshopCard()}
            setValid={(valid: boolean) => this.setState({ cardNumberIsValid: valid })}
            buttonClicked={this.state.searchButtonPressed}
            onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
          />
          <div className="fstyr-left-button-group">
            <Fstyr.Button
              label="Søg"
              onClick={() => {
                this.fetchWorkshopCard()
              }}
              disabled={this.state.showSpinner}
            />
            <Fstyr.Spinner
              show={this.state.showSpinner}
            />
          </div>
        </Fstyr.Segment>

        <Fstyr.Segment
          title="Værkstedskortinformation"
        >
          <div className="row justify-content-center">
            <div className={global.config.isPolice ? "col-sm-12 col-md-12 col-xl-12" : "col-sm-12 col-md-12 col-xl-6"}>
              <div className="fstyr-attention-box" style={{ height: "100%" }}>
                <p>Værkstedsoplysninger</p>
                <Fstyr.Input
                  label="Kortnummer"
                  readonly={true}
                  value={this.state.workshopCardVm.CardNumber}
                  direction="row"
                />

                <Fstyr.Input
                  label="Autorisations&#8203;nummer"
                  readonly={true}
                  value={formatAuthorizationNumber(this.state.workshopCardVm.AuthorizationNumber)}
                  direction="row"
                />
                <Fstyr.Input
                  label="CVR"
                  readonly={true}
                  value={this.state.workshopCardVm.Workshop.Cvr}
                  direction="row"
                />
                <Fstyr.Input
                  label="Kortholder (værksted)"
                  readonly={true}
                  value={this.state.workshopCardVm.Workshop.Responsible}
                  direction="row"
                />
                <Fstyr.Input
                  label="Kortholder (mekaniker)"
                  readonly={true}
                  value={this.state.workshopCardVm.Person.FirstName + " " + this.state.workshopCardVm.Person.LastName}
                  direction="row"
                />
                <Fstyr.Input
                  label="Gyldigheds&#8203;periode"
                  readonly={true}
                  value={this.state.cardFound ? DateFormatter(this.state.workshopCardVm.ValidFrom) + "  -  " + DateFormatter(this.state.workshopCardVm.ValidTo) : ""}
                  direction="row"
                />
                <Fstyr.Input
                  label="Status på kort"
                  direction="row"
                  readonly={true}
                  value={this.state.cardFound ? GetStatusName(this.state.workshopCardVm.Status.Id) : ""}
                />
                <Fstyr.Button
                  label="Skift status"
                  disabled={!this.state.cardFound}
                  onClick={() => { this.setState({ showStatusChange: true }) }}
                />

                {this.state.showStatusChange &&
                  <div style={{ marginTop: 15, maxWidth: 340 }}>
                    <div className="alert alert-info" style={{ marginTop: 10 }}>
                      <div className="alert-body" style={{ height: "100%" }}>
                        <p className="alert-heading">Ekstra oplysninger</p>
                        <p className="alert-text">Udfyld de nedenstående oplysninger.</p>
                        <Fstyr.Dropdown
                          items={global.config.isPolice ? filterCardStatusesPolice(require('../../assets/CardStatus.json')) : filterCardStatuses(require('../../assets/CardStatus.json'))}
                          width={"100%"}
                          onItemSelected={(status) => this.setState({ newCardStatusId: GetStatusId(require('../../assets/CardStatus.json'), status) })}
                          label="Ny status"
                        />
                        <Fstyr.Input
                          label="Dato for ændring"
                          direction="column"
                          readonly={true}
                          value={DateFormatter(new Date())}
                        />
                        <div className='fstyr-right-button-group' >
                          <Fstyr.Button
                            label="Gem"
                            onClick={() => { this.changeCardStatus() }}
                            disabled={this.state.newCardStatusId === this.baseState.newCardStatusId}
                          />
                          <Fstyr.Button
                            label="Annullér"
                            type="secondary"
                            onClick={() => this.setState({
                              showStatusChange: false,
                            })}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>

            <div style={{ height: "10px" }} className={global.config.isPolice ? "col-sm-12 col-md-12 col-lg-12 d-xl-12" : "col-sm-12 col-md-12 col-lg-12 d-xl-none"}></div>

            <div className={global.config.isPolice ? "col-sm-12 col-md-12 col-xl-12" : "col-sm-12 col-md-12 col-xl-6"}>
              <div className="fstyr-attention-box" style={{ height: "100%" }}>
                <p>Personoplysninger</p>
                <Fstyr.Input
                  label="CPR"
                  readonly={true}
                  value={this.state.workshopCardVm.Person.Cpr}
                  direction="row"
                />
                <Fstyr.Input
                  label="Fornavn"
                  readonly={true}
                  value={this.state.workshopCardVm.Person.FirstName}
                  direction="row"
                />
                <Fstyr.Input
                  label="Efternavn"
                  readonly={true}
                  value={this.state.workshopCardVm.Person.LastName}
                  direction="row"
                />
                <Fstyr.Input
                  label="Adresse"
                  readonly={true}
                  value={formatAddress(this.state.workshopCardVm.Person.Address, true)}
                  direction="row"
                />
              </div>
            </div>
          </div>
        </Fstyr.Segment>
      </>
    );
  }
}
